export default {
	paymentLanguageList: [],
	paymentMethodList: [],
	paymentStatusList: [],
}
